

// // src/components/charting/ImageSelector.tsx
// import React from "react";
// import "../../css/ImageSelector.css";

// // ✅ IMPORTANT: These values MUST match the backend keys exactly
// const VIEWS = [
//   "Anterior",
//   "Right Buccal",
//   "Left Buccal",
//   "Maxillary Occlusal",
//   "Mandibular Occlusal",
// ];

// interface ImageSelectorProps {
//   currentView: string;
//   onViewChange: (view: string) => void;
//   viewedTabs: Set<string>;          // ✅ NEW
//   requiredViews: string[];          // ✅ NEW
// }

// const ImageSelector: React.FC<ImageSelectorProps> = ({
//   currentView,
//   onViewChange,
// }) => {
//   return (
//     <div className="view-selector">
//       {VIEWS.map((view) => (
//         <button
//           key={view}
//           className={`view-btn ${currentView === view ? "active" : ""}`}
//           onClick={() => onViewChange(view)}
//         >
//           {view.replace(" Occlusal", "")}
//         </button>
//       ))}
//     </div>
//   );
// };

// export default ImageSelector;








// src/components/charting/ImageSelector.tsx
import React from "react";
import "../../css/ImageSelector.css";

// ✅ IMPORTANT: These values MUST match the backend keys exactly
const VIEWS = [
  "Anterior",
  "Right Buccal",
  "Left Buccal",
  "Maxillary Occlusal",
  "Mandibular Occlusal",
];

interface ImageSelectorProps {
  currentView: string;
  onViewChange: (view: string) => void;
  viewedTabs: Set<string>;          // ✅ NEW
  requiredViews: string[];          // ✅ NEW
}

const ImageSelector: React.FC<ImageSelectorProps> = ({
  currentView,
  onViewChange,
}) => {
  return (
    <div className="view-selector">
      {VIEWS.map((view) => (
        <button
          key={view}
          className={`view-btn ${currentView === view ? "active" : ""}`}
          onClick={() => onViewChange(view)}
        >
          {view.replace("", "")}
        </button>
      ))}
    </div>
  );
};

export default ImageSelector;